var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHuawei(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4416 1C3.52853 1 1 3.52809 1 10.4398V25.2102C1 32.1219 3.52853 34.65 10.4416 34.65H25.2039C32.1168 34.65 34.65 32.1219 34.65 25.2102V10.4398C34.65 3.52809 32.1215 1 25.2084 1H10.4416Z",
    fill: "url(#paint0_linear_303_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.678 20.5163H17.0289L16.3512 18.9401L15.678 20.5163ZM15.3453 21.3106L14.9445 22.2278H14.032L15.9725 17.8253H16.7612L18.6938 22.2278H17.757L17.3613 21.3106H15.3453ZM30.0292 22.2245H30.9111V17.825H30.0292V22.2245ZM26.5189 20.3346H28.1446V19.5324H26.5189V18.6307H28.8789V17.8283H25.6372V22.2275H28.9638V21.425H26.5189V20.3346ZM23.0146 20.8544L22.0148 17.825H21.2851L20.2852 20.8544L19.3121 17.8274H18.3606L19.8963 22.2302H20.636L21.6375 19.3382L22.639 22.2302H23.3852L24.9167 17.8274H23.9899L23.0146 20.8544ZM12.6857 20.3467C12.6857 21.0629 12.33 21.4456 11.6842 21.4456C11.0348 21.4456 10.6773 21.0518 10.6773 20.3162V17.828H9.78342V20.3467C9.78342 21.5857 10.472 22.2962 11.672 22.2962C12.8839 22.2962 13.5787 21.5722 13.5787 20.31V17.8253H12.6857V20.3467ZM7.65088 17.8253H8.5442V22.2305H7.65088V20.4414H5.63275V22.2305H4.73889V17.8253H5.63275V19.6022H7.65088V17.8253Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.825 12.2167C14.7323 12.2167 12.2167 9.70082 12.2167 6.60834H13.0089C13.0089 9.26375 15.1696 11.4242 17.825 11.4242C20.4804 11.4242 22.6412 9.26375 22.6412 6.60834H23.4333C23.4333 9.70082 20.9175 12.2167 17.825 12.2167Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_303_2",
    x1: 17.825,
    y1: 1,
    x2: 17.825,
    y2: 34.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB6361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED3E45"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuawei);
export default __webpack_public_path__ + "static/media/Huawei.05f60516d2a39d595dabc4ffdec3856a.svg";
export { ForwardRef as ReactComponent };